import { appMethod as app } from '@utils/app';

import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import util from '@utils/util';

import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './CouponReceiveListPage.less';

export default class CouponReceiveListPage extends OfficialPage {
  state = {
    topNavBarData: {
      isDefault: 0,
      title: '优惠券领取列表'
    },
    couponList: [],
    receiveSuccess: 0, // 领取成功弹窗是否显示
    receiveCount: 0, // 已领取数量
    receiveLimitNum: 0, // 领取限制数量
    userInfo: {},
    couponsAndDiscount: {},
    totalUser: 0,
    category: [],
    currentCate: -1,  // 默认选中全部分类 
    latitude: '',
    longitude: '',
    isParentShop: false,
    headquartersId: '',
    recvCouponPopFranchisee: false,
    recvCouponPopAppId: '',
    recvCouponPopAppMode: '',
    couponNoMore: false,
    recving: false // 领取中
  }

  constructor(props) {
    super(props);
    document.title = '优惠券领取列表';
  }

  componentWillMount() {
    let that = this
    let isParent = app.globalData.hasFranchiseeList
    that.setData({
      headquartersId: app.globalData.appId,
      isParentShop: isParent
    })
    if (isParent) {
      if (app.isLogin()) {
        that.setData({
          userInfo: app.globalData.userInfo
        })
      } else {
        app.goLogin({
          success: function() {
            that.setData({
              userInfo: app.globalData.userInfo
            })
          }
        })
      }
      that.getLocation()
      that.getCategoryForCoupon()
      that.getDiscountCut()
      that.getTotalUser()
    } else {
      that.getCoupons()
    }
  }

  getCoupons = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getCoupons',
      data: {
        in_use_date: 1, //0是全部，1是只显示可领取的优惠券
        in_show_list: 1, //0:不在列表内 1:在列表内
        enable_status: 1, //0:下架 1:上架
        stock: 1, //0:没有库存的 1:有库存的
        page: -1
      },
      hideLoading: true,
      success: function(res) {
        _this.setData({
          couponList: res.data
        })
      }
    })
  }
  gotoCouponDetail = event => {
    let couponId = event.currentTarget.dataset.couponId
    let appid = event.currentTarget.dataset.appid
    let franisee = ''
    if (this.data.headquartersId != appid && this.data.isParentShop) {
      franisee = '&franchisee=' + appid
    }
    let url = '/pages/couponDetail/couponDetail?detail=' + couponId + franisee
    app.turnToPage(url, false)
  }
  formSubmit = event => {
    let _this = this,
      couponId = event.currentTarget.dataset.couponId,
      formId = event.detail.formId,
      index = event.currentTarget.dataset.index
    if (this.data.recving) {
      return
    }
    this.setRecving(true)
    app.sendRequest({
      url: '/index.php?r=AppShop/recvCoupon',
      data: {
        coupon_id: couponId,
        form_id: formId
      },
      hideLoading: true,
      success: function(res) {
        let newdata = {}
        if (res.data.is_already_recv == 1) {
          newdata['couponList[' + index + '].recv_status'] = 0
        }
        newdata['receiveSuccess'] = 1
        newdata['receiveCount'] = res.data.recv_count
        newdata['receiveLimitNum'] = res.data.limit_num
        _this.setData(newdata)
      },
      complete: function() {
        _this.setRecving(false)
      }
    })
  }
  setRecving = bool => {
    this.setData({
      recving: bool
    })
  }
  formSubmitFranchisee = event => {
    let that = this,
      dataset = event.currentTarget.dataset,
      index = dataset.index,
      formId = event.detail.formId,
      item = that.data.couponList[index],
      couponId = item.id,
      appid = item.app_id,
      mode = item.mode_id
    if (this.data.recving) {
      return
    }
    this.setRecving(true)
    app.sendRequest({
      url: '/index.php?r=AppShop/recvCoupon',
      data: {
        coupon_id: couponId,
        form_id: formId,
        sub_app_id: appid
      },
      hideLoading: true,
      success: function(res) {
        let newdata = {}
        if (res.data.is_already_recv == 1) {
          newdata['couponList[' + index + '].recv_status'] = 0
        }
        newdata['recvCouponPopFranchisee'] = true
        newdata['recvCouponPopAppId'] = appid
        newdata['recvCouponPopAppMode'] = mode
        newdata['couponsAndDiscount.coupons'] =
          that.data.couponsAndDiscount.coupons + 1
        that.setData(newdata)
      },
      complete: function() {
        that.setRecving(false)
      }
    })
  }
  gotoCouponList = () => {
    let url = '/eCommerce/pages/couponList/couponList'
    app.turnToPage(url, false)
  }
  hideToast = () => {
    this.setData({
      receiveSuccess: 0,
      receiveCount: 0,
      receiveLimitNum: 0
    })
  }
  stopPropagation = () => {}
  getDiscountCut = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetCouponsAndDiscountCutTotalPrice',
      data: {},
      hideLoading: true,
      success: function(res) {
        that.setData({
          couponsAndDiscount: res.data
        })
      }
    })
  }
  getTotalUser = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetTotalUser',
      data: {},
      hideLoading: true,
      success: function(res) {
        that.setData({
          totalUser: res.data
        })
      }
    })
  }
  getCategoryForCoupon = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetCategoryForCoupon',
      data: {},
      hideLoading: true,
      success: function(res) {
        that.setData({
          category: res.data
        })
      }
    })
  }
  getLocation = () => {
    let that = this
    app.getLocation({
      success: function(res) {
        that.setData({
          longitude: res.longitude,
          latitude: res.latitude
        })
        that.getAllShopCouponList()
      },
      fail: function() {
        that.getAllShopCouponList()
      }
    })
  }
  allCouponData = {
    page: 1,
    loading: false,
    nomore: false
  }
  getAllShopCouponList = () => {
    let that = this
    if (that.allCouponData.loading || that.allCouponData.nomore) {
      return
    }
    that.allCouponData.loading = true
    app.sendRequest({
      url: '/index.php?r=AppShop/GetAllShopCouponList',
      data: {
        parent_app_id: app.globalData.appId,
        latitude: that.data.latitude,
        longitude: that.data.longitude,
        industry_type: that.data.currentCate,
        page: that.allCouponData.page,
        page_size: 10
      },
      success: function(res) {
        let oldList = that.data.couponList
        let data = res.data
        if (that.allCouponData.page == 1) {
          oldList = []
        }
        for (let index in data) {
          let distance = data[index].distance
          data[index].distance = util.formatDistance(distance)
        }
        that.setData({
          couponList: oldList.concat(data),
          couponNoMore: res.is_more == 0
        })
        that.allCouponData.page++
        that.allCouponData.nomore = res.is_more == 0
      },
      complete: function() {
        that.allCouponData.loading = false
      }
    })
  }
  gotoShop = e => {
    let appid = e.currentTarget.dataset.appid
    let mode = e.currentTarget.dataset.mode
    let chainId = app.getChainId()
    if (this.data.headquartersId == appid || chainId == appid) {
      let home = app.getHomepageRouter()
      app.reLaunch({
        url: '/pages/' + home + '/' + home
      })
    } else {
      let param = {}
      param.detail = appid
      app.goToFranchisee(mode, param)
    }
  }
  closeRecvCouponPopFranchisee = () => {
    this.setData({
      recvCouponPopFranchisee: false
    })
  }
  clickLoading = false
  changeTab = e => {
    let id = e.currentTarget.dataset.id
    if (id == this.data.currentCate) {
      return
    }
    if (this.clickLoading) {
      app.showModal({ content: '请勿频繁点击分类' })
      return
    }
    this.clickLoading = true
    setTimeout(() => {
      this.clickLoading = false
    }, 500)
    this.setData({
      currentCate: +id,
      couponNoMore: false
    })
    this.allCouponData.page = 1
    this.allCouponData.nomore = false
    this.allCouponData.loading = false
    this.getAllShopCouponList()
  }
  onReachBottom = e => {
    let that = this
    if (that.data.isParentShop) {
      that.getAllShopCouponList()
    }
  }

  render() {
    const {
      userInfo,
      totalUser,
      couponsAndDiscount,
      currentCate,
      category,
      couponList,
      couponNoMore,
      isParentShop,
      receiveSuccess,
      receiveCount,
      receiveLimitNum,
      recvCouponPopAppId,
      recvCouponPopAppMode,
      recvCouponPopFranchisee
    } = this.state
    return (
      <div className="official-page coupon-receive-list-page">
        <TopNav title="优惠券领取列表" />
        <div
          id="coupon-receive-list-page"
          className="coupon-receive-list-page"
        >
          {isParentShop ? (
            <React.Fragment>
              <div className="coupon-receive-head">
                <div className="clearfix">
                  <div className="coupon-receive-user">
                    <div className="coupon-receive-cover">
                      <img
                        src={userInfo.cover_thumb}
                        mode="aspectFill"
                      />
                    </div>
                    <div className="coupon-receive-nickname">
                      {userInfo.nickname}
                    </div>
                  </div>
                  <div className="coupon-receive-competitor">
                    {totalUser + '人正在抢'}
                  </div>
                </div>
                <div className="coupon-pft-wrap">
                  <div className="coupon-pft-item">
                    <div
                      className="coupon-pft-num"
                      onClick={this.gotoCouponList}
                    >
                      {couponsAndDiscount.coupons || 0}
                    </div>
                    <div className="coupon-pft-text">已抢优惠券（张）</div>
                  </div>
                  <div className="coupon-pft-item">
                    <div className="coupon-pft-num">
                      {couponsAndDiscount.cut_total_price || 0}
                    </div>
                    <div className="coupon-pft-text">已节省（元）</div>
                  </div>
                </div>
              </div>
              <ScrollView scroll-x="true" className="coupon-cate">
                <div
                  className={
                    'coupon-cate-item ' + (currentCate === -1 ? 'active' : '')
                  }
                  data-id={-1}
                  onClick={this.changeTab}
                >
                  全部
                </div>
                {Object.values(category).map((item, index) => {
                  return (
                    <div
                      className={
                        'coupon-cate-item ' +
                        (currentCate === index ? 'active' : '')
                      }
                      key={index}
                      data-id={index}
                      onClick={this.changeTab}
                    >
                      {item}
                    </div>
                  )
                })}
              </ScrollView>
              <div className="ticket-list">
                {couponList.map((coupon, index) => {
                  return (
                    <React.Fragment key={coupon.id}>
                      <div
                        className="ticket franchisee-ticket"
                        onClick={this.gotoCouponDetail}
                        data-coupon-id={coupon.id}
                        data-appid={coupon.app_id}
                      >
                        <div className="top-section">
                          <div className="coupon-franchisee">
                            <img
                              className="coupon-franchisee-logo"
                              mode="aspectFill"
                              src={coupon.logo}
                            />
                            <div
                              className="coupon-franchisee-name"
                              onClick={this.gotoShop}
                              data-mode={coupon.mode_id}
                              data-appid={coupon.app_id}
                            >
                              {coupon.name}
                              <label className="ico-moon icon-rightarrow"></label>
                            </div>
                            <div className="coupon-franchisee-distance">
                              {'附近' + coupon.distance}
                            </div>
                          </div>
                          {coupon.type == 0 ? (
                            <React.Fragment>
                              <div className="detail-info-franchisee">
                                <div className="coupon-value">
                                  <label>¥</label>
                                  {coupon.value}
                                </div>
                                <div className="coupon-condition">
                                  {'满' + coupon.condition + '可用'}
                                </div>
                              </div>
                            </React.Fragment>
                          ) : coupon.type == 1 ? (
                            <React.Fragment>
                              <div className="detail-info-franchisee">
                                <div className="coupon-value">
                                  {coupon.value}
                                  <label>折</label>
                                </div>
                                {coupon.extra_goods == 'null' ? (
                                  <div className="coupon-condition">
                                    全部商品可享优惠
                                  </div>
                                ) : (
                                  <div className="coupon-condition">
                                    部分商品可享优惠
                                  </div>
                                )}
                              </div>
                            </React.Fragment>
                          ) : coupon.type == 2 ? (
                            <React.Fragment>
                              <div className="detail-info-franchisee">
                                <div className="coupon-value">
                                  <label>¥</label>
                                  {coupon.value}
                                </div>
                                <div className="coupon-condition">
                                  商品代金券
                                </div>
                              </div>
                            </React.Fragment>
                          ) : coupon.type == 3 ? (
                            <React.Fragment>
                              <div className="detail-info-franchisee">
                                <div className="coupon-value">兑换券</div>
                                {coupon.extra_condition == '' ? (
                                  <div className="coupon-condition">
                                    {'直接兑换' +
                                    coupon.coupon_goods_info.title}
                                  </div>
                                ) : coupon.extra_condition.price ? (
                                  <div className="coupon-condition">
                                    {'消费满' +
                                    coupon.extra_condition.price +
                                    '元可兑换' +
                                    coupon.coupon_goods_info.title}
                                  </div>
                                ) : (
                                  coupon.extra_condition.goods_id && (
                                    <div className="coupon-condition">
                                      {'购买' +
                                      coupon.condition_goods_info.title +
                                      '可兑换' +
                                      coupon.coupon_goods_info.title}
                                    </div>
                                  )
                                )}
                              </div>
                            </React.Fragment>
                          ) : coupon.type == 4 ? (
                            <React.Fragment>
                              <div className="detail-info-franchisee">
                                <div className="coupon-value">
                                  <label>¥</label>
                                  {coupon.value}
                                </div>
                                <div className="coupon-condition">
                                  商品储值金
                                </div>
                              </div>
                            </React.Fragment>
                          ) : coupon.type == 5 ? (
                            <React.Fragment>
                              <div className="detail-info-franchisee">
                                <div className="coupon-value">通用券</div>
                                <div className="coupon-condition">
                                  {coupon.extra_condition}
                                </div>
                              </div>
                            </React.Fragment>
                          ) : (
                            coupon.type == 6 && (
                              <React.Fragment>
                                <div className="detail-info-franchisee">
                                  <div className="coupon-value">次数券</div>
                                  <div className="coupon-condition">
                                    {'可兑换' + coupon.limit_num + '次'}
                                  </div>
                                </div>
                              </React.Fragment>
                            )
                          )}
                          <form
                            onSubmit={this.formSubmitFranchisee}
                            data-index={index}
                          >
                            {coupon.recv_status == 1 ? (
                              <button
                                className="receive-btn"
                                onClick={this.stopPropagation}
                              >
                                领取
                              </button>
                            ) : (
                              coupon.recv_status == 0 && (
                                <div
                                  className="receive-btn"
                                  onClick={this.gotoShop}
                                  data-mode={coupon.mode_id}
                                  data-appid={coupon.app_id}
                                >
                                  去使用
                                </div>
                              )
                            )}
                          </form>
                        </div>
                        <div className="bottom-section">
                          <div>
                            {'有效期 ' +
                            (coupon.expire == '-1'
                              ? coupon.start_use_date +
                              '至' +
                              coupon.end_use_date
                              : coupon.expire == '0'
                                ? '领取当天生效,有效期1天'
                                : '领取' +
                                (coupon.react > 0
                                  ? coupon.react + '天后'
                                  : '当天') +
                                '生效，有效期' +
                                coupon.expire +
                                '天') +
                            ' ' +
                            (coupon.exclude_holiday == 0
                              ? ''
                              : '除去法定节假日') +
                            ' ' +
                            (coupon.exclude_weekend == 0
                              ? ''
                              : '周一至周五') +
                            ' ' +
                            coupon.start_use_time +
                            '-' +
                            coupon.end_use_time}
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                )
                })}
                </div>
                  {couponNoMore && (
                    <div className="coupon-no-more">没有更多了</div>
                  )}
                </React.Fragment>
                ) : (
                    <React.Fragment>
                      <div className="ticket-list">
                        {couponList.map((coupon, index) => {
                          return (
                            <React.Fragment key={coupon.id}>
                              <div
                                className={
                                  'ticket ' +
                                  (coupon.recv_status == 1 ? '' : 'has-receive')
                                }
                                onClick={this.gotoCouponDetail}
                                data-coupon-id={coupon.id}
                              >
                                <div
                                  className="top-section"
                                  style={convertLineStyleData('border-color: ' + coupon.list_color)}
                                >
                                  {coupon.type == 0 ? (
                                    <React.Fragment>
                                      <div className="detail-info">
                                        <div className="name">{coupon.title}</div>
                                        <div className="use-condition">
                                          {'使用条件：满' +
                                          coupon.condition +
                                          '元，减' +
                                          coupon.value +
                                          '元'}
                                        </div>
                                      </div>
                                      <div
                                        className="background-word-area"
                                        style={convertLineStyleData('border-color:' + coupon.list_color)}
                                      >
                                        <div
                                          className="background-circle"
                                          style={convertLineStyleData(
                                            'background-color:' + coupon.list_color
                                          )}
                                        ></div>
                                        <div className="background-word">减</div>
                                      </div>
                                    </React.Fragment>
                                  ) : coupon.type == 1 ? (
                                    <React.Fragment>
                                      <div className="detail-info">
                                        <div className="name">{coupon.title}</div>
                                        <div className="use-condition">
                                          {'使用条件: 打' + coupon.value + '折'}
                                        </div>
                                      </div>
                                      <div
                                        className="background-word-area"
                                        style={convertLineStyleData('border-color:' + coupon.list_color)}
                                      >
                                        <div
                                          className="background-circle"
                                          style={convertLineStyleData(
                                            'background-color:' + coupon.list_color
                                          )}
                                        ></div>
                                        <div className="background-word">折</div>
                                      </div>
                                    </React.Fragment>
                                  ) : coupon.type == 2 ? (
                                    <React.Fragment>
                                      <div className="detail-info">
                                        <div className="name">{coupon.title}</div>
                                        <div className="use-condition">
                                          {'使用条件：可抵扣' + coupon.value + '元'}
                                        </div>
                                      </div>
                                      <div
                                        className="background-word-area"
                                        style={convertLineStyleData('border-color:' + coupon.list_color)}
                                      >
                                        <div
                                          className="background-circle"
                                          style={convertLineStyleData(
                                            'background-color:' + coupon.list_color
                                          )}
                                        ></div>
                                        <div className="background-word">代</div>
                                      </div>
                                    </React.Fragment>
                                  ) : coupon.type == 3 ? (
                                    <React.Fragment>
                                      <div className="detail-info">
                                        <div className="name">{coupon.title}</div>
                                        {coupon.extra_condition == '' ? (
                                          <div className="use-condition">
                                            {'使用条件：直接兑换' +
                                            coupon.coupon_goods_info.title}
                                          </div>
                                        ) : coupon.extra_condition.price ? (
                                          <div className="use-condition">
                                            {'使用条件：消费满' +
                                            coupon.extra_condition.price +
                                            '元可兑换' +
                                            coupon.coupon_goods_info.title}
                                          </div>
                                        ) : (
                                          coupon.extra_condition.goods_id && (
                                            <div className="use-condition">
                                              {'使用条件：购买' +
                                              coupon.condition_goods_info.title +
                                              '可兑换' +
                                              coupon.coupon_goods_info.title}
                                            </div>
                                          )
                                        )}
                                      </div>
                                      <div
                                        className="background-word-area"
                                        style={convertLineStyleData('border-color:' + coupon.list_color)}
                                      >
                                        <div
                                          className="background-circle"
                                          style={convertLineStyleData(
                                            'background-color:' + coupon.list_color
                                          )}
                                        ></div>
                                        <div className="background-word">兑</div>
                                      </div>
                                    </React.Fragment>
                                  ) : coupon.type == 4 ? (
                                    <React.Fragment>
                                      <div className="detail-info">
                                        <div className="name">{coupon.title}</div>
                                        <div className="use-condition">
                                          {'使用条件: 储值金可充值' +
                                          coupon.value +
                                          '元'}
                                        </div>
                                      </div>
                                      <div
                                        className="background-word-area"
                                        style={convertLineStyleData('border-color:' + coupon.list_color)}
                                      >
                                        <div
                                          className="background-circle"
                                          style={convertLineStyleData(
                                            'background-color:' + coupon.list_color
                                          )}
                                        ></div>
                                        <div className="background-word">储</div>
                                      </div>
                                    </React.Fragment>
                                  ) : coupon.type == 5 ? (
                                    <React.Fragment>
                                      <div className="detail-info">
                                        <div className="name">{coupon.title}</div>
                                        <div className="use-condition">
                                          {'使用条件: ' + coupon.extra_condition}
                                        </div>
                                      </div>
                                      <div
                                        className="background-word-area"
                                        style={convertLineStyleData('border-color:' + coupon.list_color)}
                                      >
                                        <div
                                          className="background-circle"
                                          style={convertLineStyleData(
                                            'background-color:' + coupon.list_color
                                          )}
                                        ></div>
                                        <div className="background-word">通</div>
                                      </div>
                                    </React.Fragment>
                                  ) : (
                                    coupon.type == 6 && (
                                      <React.Fragment>
                                        <div className="detail-info">
                                          <div className="name">{coupon.title}</div>
                                          <div className="coupon-condition">
                                            {'使用条件: 可使用' + coupon.value + '次'}
                                          </div>
                                        </div>
                                        <div
                                          className="background-word-area"
                                          style={convertLineStyleData('border-color:' + coupon.list_color)}
                                        >
                                          <div
                                            className="background-circle"
                                            style={convertLineStyleData(
                                              'background-color:' + coupon.list_color
                                            )}
                                          ></div>
                                          <div className="background-word">次</div>
                                        </div>
                                      </React.Fragment>
                                    )
                                  )}
                                  <form
                                    onSubmit={this.formSubmit}
                                    data-coupon-id={coupon.id}
                                    data-index={index}
                                  >
                                    {coupon.recv_status == 1 ? (
                                      <button
                                        className="receive-btn"
                                        onClick={this.stopPropagation}
                                        style={convertLineStyleData('background-color:' + coupon.list_color)}
                                      >
                                        领取
                                      </button>
                                    ) : (
                                      coupon.recv_status == 0 && (
                                        <div className="receive-btn">已领取</div>
                                      )
                                    )}
                                  </form>
                                </div>
                                <div className="bottom-section">
                                  <div>
                                    {'有效期 ' +
                                    (coupon.expire == '-1'
                                      ? coupon.start_use_date +
                                      '至' +
                                      coupon.end_use_date
                                      : coupon.expire == '0'
                                        ? '领取当天生效,有效期1天'
                                        : '领取' +
                                        (coupon.react > 0
                                          ? coupon.react + '天后'
                                          : '当天') +
                                        '生效，有效期' +
                                        coupon.expire +
                                        '天') +
                                    ' ' +
                                    (coupon.exclude_holiday == 0
                                      ? ''
                                      : '除去法定节假日') +
                                    ' ' +
                                    (coupon.exclude_weekend == 0
                                      ? ''
                                      : '周一至周五') +
                                    ' ' +
                                    coupon.start_use_time +
                                    '-' +
                                    coupon.end_use_time}
                                  </div>
                                </div>
                              </div>
                            </React.Fragment>
                          )
                        })}
                      </div>
                      <div className="goto-coupon-list">
                        <div onClick={this.gotoCouponList}>查看我的优惠券>>></div>
                      </div>
                    </React.Fragment>
                  )}
                  <div
                    className={'zc-toast-bg ' + (receiveSuccess == 1 ? 'show' : '')}
                    onClick={this.hideToast}
                  >
                    <div className="zc-toast">
                      <span className="icon" type="success" size="20"></span>
                      <div className="title">领取成功!</div>
                      <div className="content">
                      {'已领' + receiveCount + '张，限领' + receiveLimitNum + '张'}
                      </div>
                    </div>
                  </div>
                {recvCouponPopFranchisee && (
                  <div className="pop-wrap">
                    <div
                      className="pop-bg"
                      onClick={this.closeRecvCouponPopFranchisee}
                    ></div>
                    <div className="pop-inner">
                      <label
                      className="pop-close ico-moon icon-closes"
                      onClick={this.closeRecvCouponPopFranchisee}
                      ></label>
                      <div className="recvCoupon-success">
                        <span type="success" size="14" color="#FF7100"></span>
                        <label>恭喜领取成功</label>
                      </div>
                      <div
                        className="recvCoupon-pop-btn"
                        data-appid={recvCouponPopAppId}
                        data-mode={recvCouponPopAppMode}
                        onClick={this.gotoShop}
                      >
                        进店购物，立享优惠
                      </div>
                    </div>
                  </div>
                  )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/coupon-receive-list-page/CouponReceiveListPage.jsx